import { NotificationStatusType } from '@/models/app-common.model';
import { ErrorWithMessageResponse } from '@/models/app-internal/error-with-message.model';
import { notifyErrorOnce } from '@marfa/bo-utils';
import { ElNotification } from 'element-plus';

export const showErrorNotification = (
  error: unknown,
  fallbackMessage = 'Something went wrong',
): void => {
  const err = error as ErrorWithMessageResponse | null | undefined;

  notifyErrorOnce(error, () => {
    ElNotification({
      title: 'Error',
      message: err?.response?.data?.message ?? err?.message ?? fallbackMessage,
      type: NotificationStatusType.ERROR,
    });
  });
};

export const showSuccessNotification = (message: string): void => {
  ElNotification({
    title: 'Success',
    message,
    type: NotificationStatusType.SUCCESS,
  });
};
